module.exports = __webpack_public_path__ + "img/Weilin platform equipment monitoring software.fd36fd95.jpg";